<template>
	<Card
		class="ProgrammeCard"
		:featured="programme?.isFeatured"
		:loading="loading"
		@click="handleCardClick"
		@visible="handleCardVisible"
	>
		<ProgrammeHeader
			:organizationName="programme?.organizationName"
			:organizationLogoUrl="programme?.organizationLogoUrl"
			:programmeId="programme?.id"
			:reviewRating="programme?.reviewRating"
			:ranking="programme?.ranking"
			:locations="programme?.locations"
			:showLogo="programme?.isFeatured"
			:loading="loading"
			:externalServicesLoading="externalServicesLoading"
		/>

		<ProgrammeDetails
			:programmeTitle="programme?.title"
			:summary="programme?.summary"
			:loading="loading"
		/>

		<div class="FactsArea">
			<ProgrammeFacts
				:facts="programme?.standardFacts"
				:loading="loading"
			/>

			<ProgrammePrice
				class="ProgrammePrice desktop"
				:tuition="programme?.tuition ?? null"
				:duration="programme?.duration || ''"
				:loading="loading"
			/>
		</div>

		<ProgrammePrice
			class="ProgrammePrice mobile"
			:tuition="programme?.tuition ?? null"
			:duration="programme?.duration || ''"
			:loading="loading"
		/>

		<template #right-footer>
			<a
				v-skeleton="{
					loading,
					sizes: {
						Small: { width: '10.75rem', height: '0.75rem' },
						ExtraLarge: { width: '12.563rem', height: '1.75rem' },

					}
				}"
				class="VisitProgramme"
				:href="programme?.url"
				:target="isMobile ? '_self' : '_blank'"
			>
				View Programme Information
			</a>
		</template>
	</Card>
</template>

<script setup lang="ts">
import { type PropType } from 'vue';
import type IPersonalizedProgrammeCard from '@app/interfaces/dtos/IPersonalizedProgrammeCard';
import Card from '@components/SearchResults/Card/Card.vue';
import ProgrammeHeader from './ProgrammeHeader/ProgrammeHeader.vue';
import ProgrammeDetails from './ProgrammeDetails/ProgrammeDetails.vue';
import ProgrammeFacts from './ProgrammeFacts/ProgrammeFacts.vue';
import ProgrammePrice from './ProgrammePrice/ProgrammePrice.vue';
import { useMobile } from '@composables/useMobile';
const { isMobile } = useMobile();

const props = defineProps({
	programme: {
		type: Object as PropType<IPersonalizedProgrammeCard>,
		required: false,
	},
	loading: {
		type: Boolean,
		default: true,
	},
	externalServicesLoading: {
		type: Boolean,
		default: false,
	},
});

const handleCardClick = () => {
	window.open(props.programme?.url, isMobile.value ? '_self' : '_blank');
};

const handleCardVisible = () => {
	console.log('Card is visible in viewport!');
};

</script>

<style scoped lang="scss">
	.ProgrammeCard {
		cursor: pointer;

		.VisitProgramme {
			color: $Blue-700;
			text-decoration: none;

			@include TextStyle(UiSmallSemibold);

			&:hover {
				text-decoration: underline;
			}

			@include Breakpoint(Large, ExtraLarge) {
				@include TextStyle(UiMediumSemibold);
			}
		}

		.FactsArea {
			display: flex;
			justify-content: space-between;
			width: 100%;
		}

		.ProgrammePrice {
			&.desktop {
				display: none;
			}

			&.mobile {
				display: flex;
			}
		}

		@include Breakpoint(Large, ExtraLarge) {
			.ProgrammePrice {
				&.desktop {
					display: flex;
				}

				&.mobile {
					display: none;
				}
			}
		}
	}
</style>
